import { takeLatest, put, call } from 'redux-saga/effects';
import get from 'lodash/get';
import FactorySaga from 'yoda-site-components/lib/sagas/FactorySaga';
import { getVipOffersApi, selectVipOfferApi } from 'yoda-interfaces/lib/Rewards/RewardsApi';
import {
    GET_VIP_OFFERS,
    GET_VIP_OFFERS_SUCCESS,
    GET_VIP_OFFERS_ERROR,
    CONFIRM_REWARD_SELECTION,
    CONFIRM_REWARD_SELECTION_SUCCESS,
    CONFIRM_REWARD_SELECTION_ERROR,
} from '../actionTypes/AnnualRewardsActionTypes';

export function* getVipOffersSaga(action) {
    try {
        const vipResponse = get(yield call(FactorySaga, getVipOffersApi, action), 'response', {});
        const offers = get(vipResponse, 'data.offers', null);
        if (Array.isArray(offers)) {
            const offerSelection = get(vipResponse, 'data.offerSelection', null);
            yield put({ type: GET_VIP_OFFERS_SUCCESS, offers, offerSelection });
        } else if (vipResponse.status !== 200) {
            throw vipResponse;
        }
    } catch (error) {
        yield put({ type: GET_VIP_OFFERS_ERROR, error });
    }
}

export function* confirmRewardSelectionSaga(action) {
    try {
        const selectVipOfferResult = yield call(FactorySaga, selectVipOfferApi, action);
        const { offerId, offerCode } = action.payload;
        if (selectVipOfferResult.isSuccess) {
            yield put({
                type: CONFIRM_REWARD_SELECTION_SUCCESS,
                selectedReward: { offerId, offerCode },
            });
        } else {
            yield put({
                type: CONFIRM_REWARD_SELECTION_ERROR,
                confirmVipRewardError: 'Something went wrong. Please try again later',
            });
        }
    } catch (error) {
        yield put({
            type: CONFIRM_REWARD_SELECTION_ERROR,
            confirmVipRewardError: 'Something went wrong. Please try again later',
        });
    }
}

export default function* watchAnnualRewardsSaga() {
    yield takeLatest(GET_VIP_OFFERS, getVipOffersSaga);
    yield takeLatest(CONFIRM_REWARD_SELECTION, confirmRewardSelectionSaga);
}

watchAnnualRewardsSaga.sagaName = 'annualRewardsSaga';
